
















import { Component, Vue, Prop } from 'vue-property-decorator';
import * as puzzle from '@/puzzle';
import { ElInputNumber } from 'element-ui/types/input-number';

@Component<PuzzleCalculatorOutput>({
  components: {},
})
export default class PuzzleCalculatorOutput extends Vue {
  @Prop({ required: true, type: String })
  padValue!: string;
  output: number = 0;

  $refs!: {
    output: ElInputNumber;
  };

  get puzzle(): puzzle.Puzzle {
    const ret: puzzle.Puzzle = {
      operands: [],
      operators: [],
      output: this.output,
    };
    for (const i of this.padValue.split('')) {
      const operand = Number.parseInt(i, 10);
      if (isNaN(operand)) {
        ret.operators.push(i);
      } else {
        ret.operands.push(operand);
      }
    }
    return ret;
  }

  get valid() {
    return (
      this.puzzle.operands.length - this.puzzle.operators.length === 1 &&
      this.puzzle.operators.length > 0
    );
  }
  get answer(): string | undefined {
    if (!this.valid) {
      return undefined;
    }

    const answer = puzzle.findFirstCorrectAnswer(this.puzzle);
    return answer && puzzle.formatAnswer(answer);
  }
}
